import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="px-4 py-4">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-2 -ml-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeftIcon className="h-5 w-5" />
            </button>
            <h1 className="text-lg font-bold">이용약관</h1>
          </div>
        </div>
      </div>

      <div className="px-4 py-6">
        <div className="bg-white rounded-xl shadow-sm p-6 space-y-6">
          <div>
            <p className="text-sm text-gray-600 mb-4">시행일: 2025년 1월 1일</p>
          </div>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제1조 (목적)</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              이 약관은 건기 프로젝트(이하 "회사")가 제공하는 건축/시공 중계 플랫폼 서비스(이하 "서비스")의 이용조건 및 절차, 회사와 회원 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제2조 (정의)</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li>
                <span className="font-medium">1. "서비스"</span>란 회사가 제공하는 건축/시공 프로젝트 관리 및 중계 관련 제반 서비스를 의미합니다.
              </li>
              <li>
                <span className="font-medium">2. "회원"</span>이란 이 약관에 따라 회사와 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 고객, 소장, VIP 고객을 말합니다.
              </li>
              <li>
                <span className="font-medium">3. "프로젝트"</span>란 고객이 요청한 건축/시공 작업 단위를 의미합니다.
              </li>
              <li>
                <span className="font-medium">4. "소장"</span>이란 회사와 계약을 맺고 실제 시공 업무를 수행하는 시공업체 대표 또는 담당자를 말합니다.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제3조 (약관의 효력 및 변경)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① 이 약관은 서비스를 이용하려는 모든 회원에게 그 효력이 발생합니다.</li>
              <li>② 회사는 필요한 경우 약관을 변경할 수 있으며, 변경된 약관은 서비스 내 공지사항을 통해 공지합니다.</li>
              <li>③ 회원이 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제4조 (서비스의 제공)</h2>
            <p className="text-sm text-gray-700 leading-relaxed mb-2">회사는 다음과 같은 서비스를 제공합니다:</p>
            <ul className="space-y-1 text-sm text-gray-700">
              <li className="pl-4">• 건축/시공 프로젝트 접수 및 관리</li>
              <li className="pl-4">• 고객과 소장 간 매칭 서비스</li>
              <li className="pl-4">• 실시간 메시징 및 파일 공유</li>
              <li className="pl-4">• 프로젝트 진행 상황 추적 및 관리</li>
              <li className="pl-4">• VIP 회원 리워드 프로그램</li>
              <li className="pl-4">• 기타 회사가 정하는 서비스</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제5조 (회원가입 및 계정)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① 회원가입은 회사가 정한 절차에 따라 신청하고 회사의 승인을 받아야 합니다.</li>
              <li>② 회원은 정확한 정보를 제공해야 하며, 변경사항이 있을 경우 즉시 수정해야 합니다.</li>
              <li>③ 회원은 자신의 계정 정보를 안전하게 관리할 책임이 있습니다.</li>
              <li>④ 고객은 프로젝트별 URL을 통해 로그인 없이 서비스를 이용할 수 있습니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제6조 (회원의 의무)</h2>
            <p className="text-sm text-gray-700 leading-relaxed mb-2">회원은 다음 행위를 하여서는 안 됩니다:</p>
            <ul className="space-y-1 text-sm text-gray-700">
              <li className="pl-4">• 타인의 정보 도용</li>
              <li className="pl-4">• 서비스 운영을 방해하는 행위</li>
              <li className="pl-4">• 허위 정보의 제공</li>
              <li className="pl-4">• 저작권 등 타인의 권리를 침해하는 행위</li>
              <li className="pl-4">• 기타 불법적이거나 부당한 행위</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제7조 (프로젝트 계약 및 수수료)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① 프로젝트 계약은 고객과 소장 간에 직접 체결됩니다.</li>
              <li>② 소장은 회사가 정한 수수료 정책에 따라 수수료를 납부해야 합니다.</li>
              <li>③ 수수료율은 공사 유형과 금액에 따라 차등 적용됩니다.</li>
              <li>④ 수수료 미납 시 서비스 이용이 제한될 수 있습니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제8조 (VIP 리워드 프로그램)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① VIP 회원은 완료된 프로젝트 금액의 일정 비율을 포인트로 적립받습니다.</li>
              <li>② 적립된 포인트는 회사가 정한 방법으로 사용하거나 출금할 수 있습니다.</li>
              <li>③ 포인트 적립률 및 사용 조건은 회사 정책에 따라 변경될 수 있습니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제9조 (서비스 중단)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① 회사는 시스템 점검, 보수, 교체 등의 사유로 서비스를 일시적으로 중단할 수 있습니다.</li>
              <li>② 천재지변 등 불가항력적인 사유로 서비스가 중단될 수 있습니다.</li>
              <li>③ 서비스 중단 시 사전에 공지하며, 긴급한 경우 사후에 공지할 수 있습니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제10조 (책임제한)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① 회사는 중계 플랫폼 제공자로서 고객과 소장 간의 계약에 직접적인 당사자가 아닙니다.</li>
              <li>② 시공 품질, 하자보수, 계약 분쟁 등은 고객과 소장 간에 해결해야 합니다.</li>
              <li>③ 회사는 회원 간 발생한 분쟁에 대해 조정 역할을 할 수 있으나, 법적 책임을 지지 않습니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제11조 (개인정보보호)</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              회사는 회원의 개인정보를 중요시하며, 개인정보보호법 등 관련 법령을 준수합니다. 
              자세한 사항은 개인정보처리방침에 따릅니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제12조 (손해배상)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① 회원이 약관을 위반하여 회사에 손해를 입힌 경우, 해당 회원은 손해를 배상해야 합니다.</li>
              <li>② 회사의 고의 또는 중과실로 회원에게 손해가 발생한 경우, 회사는 손해를 배상합니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제13조 (분쟁해결)</h2>
            <ol className="space-y-2 text-sm text-gray-700">
              <li>① 회사와 회원 간 발생한 분쟁은 상호 협의하여 해결합니다.</li>
              <li>② 협의가 이루어지지 않는 경우, 대한민국 법령에 따라 관할 법원에서 해결합니다.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">제14조 (준거법)</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              이 약관은 대한민국 법령에 따라 규율되고 해석됩니다.
            </p>
          </section>

          <section className="border-t pt-6">
            <h2 className="text-lg font-bold text-gray-900 mb-3">부칙</h2>
            <p className="text-sm text-gray-700">
              이 약관은 2025년 1월 1일부터 시행됩니다.
            </p>
          </section>

          <section className="bg-gray-50 rounded-lg p-4">
            <h3 className="text-sm font-bold text-gray-900 mb-2">고객센터</h3>
            <p className="text-sm text-gray-700">전화: 1566-0622</p>
            <p className="text-sm text-gray-700">이메일: support@geongi.kr</p>
            <p className="text-sm text-gray-700">운영시간: 평일 09:00 - 18:00</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;